/**
 * @generated SignedSource<<7bdf34283f41377a170b742281a561c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type OrderStatus = "abandoned" | "advance" | "canceled" | "draft" | "paid" | "pending" | "trash";
import { FragmentRefs } from "relay-runtime";
export type OrderStatus_order$data = {
  readonly status: OrderStatus;
  readonly " $fragmentType": "OrderStatus_order";
};
export type OrderStatus_order$key = {
  readonly " $data"?: OrderStatus_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderStatus_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderStatus_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "501a2cb676ccb1b66d7cd4b31eaa180f";

export default node;
